// Color palettes and typography shared across the Now Map UI.

export const TONE = 'energetic'

export const PALETTES = {
    calm: {
        posHue: 150,
        negHue: 25,
        sectorL: [96, 92, 88],
        sectorC: [0.008, 0.016, 0.026],
        bg: 'oklch(98% 0.004 90)',
        panelBg: 'oklch(99% 0.003 90)',
        ink: 'oklch(24% 0.008 90)',
        sub: 'oklch(48% 0.006 90)',
        line: 'oklch(85% 0.006 90)',
    },
    energetic: {
        posHue: 152,
        negHue: 18,
        sectorL: [94, 87, 78],
        sectorC: [0.02, 0.05, 0.09],
        bg: 'oklch(97% 0.006 95)',
        panelBg: 'oklch(99% 0.004 95)',
        ink: 'oklch(20% 0.01 95)',
        sub: 'oklch(45% 0.01 95)',
        line: 'oklch(82% 0.01 95)',
    },
    playful: {
        posHue: 165,
        negHue: 340,
        sectorL: [95, 89, 82],
        sectorC: [0.02, 0.05, 0.09],
        bg: 'oklch(98% 0.01 85)',
        panelBg: 'oklch(99% 0.006 85)',
        ink: 'oklch(24% 0.01 85)',
        sub: 'oklch(48% 0.01 85)',
        line: 'oklch(85% 0.01 85)',
    },
}

export const HEAD_FONT = "'Source Serif 4', Georgia, serif"
export const BODY_FONT = "'IBM Plex Sans', system-ui, -apple-system, sans-serif"

export const colorFor = (valence, level, palette) => {
    const hue = valence === 'positive' ? palette.posHue : palette.negHue
    return `oklch(${palette.sectorL[level]}% ${palette.sectorC[level]} ${hue})`
}
